// extracted by mini-css-extract-plugin
module.exports = {"section":"ChooseAccountForPaymentMethodsModal_section__3ePyK","name":"ChooseAccountForPaymentMethodsModal_name__24ffg"};